var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-print",
    clipPath: "url(#clip0_567_82892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 4C19 2.93913 18.5786 1.92172 17.8284 1.17157C17.0783 0.421427 16.0609 0 15 0L9 0C7.93913 0 6.92172 0.421427 6.17157 1.17157C5.42143 1.92172 5 2.93913 5 4V5H19V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 15H8C6.34315 15 5 16.3431 5 18V21C5 22.6569 6.34315 24 8 24H16C17.6569 24 19 22.6569 19 21V18C19 16.3431 17.6569 15 16 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19 7H5C3.67441 7.00159 2.40356 7.52888 1.46622 8.46622C0.528882 9.40356 0.00158786 10.6744 0 12L0 16C0.00127838 16.9718 0.285705 17.9221 0.818499 18.7348C1.35129 19.5475 2.10936 20.1873 3 20.576V18C3.00159 16.6744 3.52888 15.4036 4.46622 14.4662C5.40356 13.5289 6.67441 13.0016 8 13H16C17.3256 13.0016 18.5964 13.5289 19.5338 14.4662C20.4711 15.4036 20.9984 16.6744 21 18V20.576C21.8906 20.1873 22.6487 19.5475 23.1815 18.7348C23.7143 17.9221 23.9987 16.9718 24 16V12C23.9984 10.6744 23.4711 9.40356 22.5338 8.46622C21.5964 7.52888 20.3256 7.00159 19 7ZM18 11H16C15.7348 11 15.4804 10.8946 15.2929 10.7071C15.1054 10.5196 15 10.2652 15 10C15 9.73478 15.1054 9.48043 15.2929 9.29289C15.4804 9.10536 15.7348 9 16 9H18C18.2652 9 18.5196 9.10536 18.7071 9.29289C18.8946 9.48043 19 9.73478 19 10C19 10.2652 18.8946 10.5196 18.7071 10.7071C18.5196 10.8946 18.2652 11 18 11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_82892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.6fc53e13d4c1a96361a0cc8c76bdabd7.svg";
export { ForwardRef as ReactComponent };